export interface BackendState {
    isCommunicating: boolean;
    error: boolean;
    meta?: any;
}

export interface BackendStateWithData<S> extends BackendState {
    data: S;
}

export interface ReactSelectOption {
    label: string;
    value: any;
}

export class PrimeError extends Error {
    public description: string;
    public showGeneric: boolean;

    constructor(message: string, desc: string, generic: boolean) {
        super(message);
        this.description = desc;
        this.showGeneric = generic;

        // Set the prototype explicitly.
        Object.setPrototypeOf(this, PrimeError.prototype);
    }
}
